export default __webpack_public_path__ + "static/Shari Wooldridge-e9e9cda2e8187e23e7486890a62f2129.jpg";